import { useMemo } from "react";

import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import doesContainFilterModel from "@app/util/filters/doesContainFilterModel";

// This function ensures that currentFilter contains expectedFilter as a subset.
// If strictMatch is true, then both filters models must be equal to return true
const useStatus = (
  expectedFilterModel: Partial<FilterModel>,
  currentFilterModel: FilterModel,
  implicitFilterFields?: IField[],
  strictMatch?: boolean
): boolean =>
  useMemo(
    () =>
      doesContainFilterModel(
        expectedFilterModel,
        currentFilterModel,
        implicitFilterFields,
        strictMatch
      ),
    [expectedFilterModel, currentFilterModel, implicitFilterFields, strictMatch]
  );

export default useStatus;
